import { API } from '@/utils/configs/axios.config'
import ISearchDomainResponse from '@/types/response/search-domain.response.interface'
import ITld from '@/types/tld.interface'

const DomainService = {
  async getAllTlds() {
    const tlds = (await API.get<ITld[]>('/pm/public/tld.json')).data.sort(
      (first, second) => first.priority - second.priority
    )
    return tlds
      .filter((domain) => domain.available)
      .map(DomainService.genTldWithoutUnnecessaryFields)
  },

  genTldWithoutUnnecessaryFields(tld: ITld) {
    const {
      permanent,
      registration_time,
      renew_time,
      renew_due_days,
      renew_after_days,
      additional_parameters,
      ...rest
    } = tld
    return rest
  },

  async searchDomain({ domainName }: { domainName: string }): Promise<ISearchDomainResponse> {
    const response = await API.post<ISearchDomainResponse>('/public/pm/check-domain', {
      domainName,
    })

    return response.data
  },

  async whois({ domainName }: { domainName: string }) {
    const response = await API.post<{ whois_info: string }>(`/public/api/v1/whois`, {
      domain: domainName,
    })

    return response.data
  },
}

export default DomainService
